import {Component, EventEmitter, Input, Output} from '@angular/core';
import {routesNames} from "@app/app-routing.module";
import {IsPriceHiddenUseCase} from '@app/core/delivery-point/application/is-price-hidden.use-case';
import {Product} from "@app/core/product/domain/dtos/product";
import {IsLoggedInUseCase} from "@app/core/user/application/isLoggedIn.use-case";
import {combineLatest} from 'rxjs';
import {map} from 'rxjs/operators';
import {IsGuestUseCase} from "@app/core/user/application/is-guest.use-case";
import {UrlService} from "@app/presentation/services/url.service";
import {PresentationConstants} from "@app/presentation/presentation.constants";

@Component({
  selector: 'ep-product-portrait-tile-info',
  templateUrl: './product-portrait-tile-info.component.html',
  styleUrls: ['./product-portrait-tile-info.component.scss']
})
export class ProductPortraitTileInfoComponent {

  @Input() product?: Product;

  @Input() hasAddToListButton = true;

  @Input() hasDeleteButton = false;

  @Input() displayPriceOnHover = false;

  @Output() onClickDeleteButton = new EventEmitter<Product>()

  @Output() onClick = new EventEmitter<Product | undefined>();

  routesNames = routesNames;

  isLoggedIn$ = this.isLoggedInUseCase.execute();
  isPriceHidden$ = this.isPriceHiddenUseCase.execute();
  isGuest$ = this.isGuestUseCase.execute();

  canDisplayPrices$ = combineLatest([this.isLoggedIn$, this.isPriceHidden$]).pipe(
    map(([isLoggedIn, isPriceHidden]) => isLoggedIn && !isPriceHidden)
  );

  canDisplayHoverPrices$ = this.canDisplayPrices$.pipe(
    map(canDisplayPrices => canDisplayPrices && this.displayPriceOnHover)
  );  
  

  constructor(
    private isLoggedInUseCase: IsLoggedInUseCase,
    private isPriceHiddenUseCase: IsPriceHiddenUseCase,
    private isGuestUseCase: IsGuestUseCase,
    private urlService: UrlService,
  ) {
  }


  getSeoFriendlySlug(name?: string) {
    return name ? this.urlService.createSeoFriendlySlug(name) : null;
  }

  getProductUrl(product?: Product) {
    return ['/', routesNames.productDetails, product?.code, this.getSeoFriendlySlug(product?.name)]
  }


    protected readonly PresentationConstants = PresentationConstants;
}
